import StatusBadge from "@/components/common/StatusBadge";

export function DataTable({ columns, rows, testId, empty = "No records found", onRowClick }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-[#e5e9f0] bg-white shadow-sm" data-testid={testId}>
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-[#e5e9f0] bg-[#f7f8fa]">
            {columns.map((c) => (
              <th key={c.key}
                  className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-[#6a6d70] whitespace-nowrap">
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={columns.length} className="px-4 py-10 text-center text-[#6a6d70]">{empty}</td></tr>
          )}
          {rows.map((row, i) => (
            <tr key={row.id || i}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                className={`border-b border-[#eff1f4] last:border-0 transition-colors hover:bg-[#f5f6f7] ${onRowClick ? "cursor-pointer" : ""}`}>
              {columns.map((c) => (
                <td key={c.key} className="px-4 py-2.5 text-[#32363a] whitespace-nowrap">
                  {c.badge ? <StatusBadge status={row[c.key]} />
                    : c.render ? c.render(row) : row[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
